export class Maestro_DashBoard {
    id: number;
    dashboard: string;
    nombreComponente: string;
}